export default {
  listMailFolder: [],
  selectedMailFolder: null,
}